import BeeswaxSegmentUserCountRegion from '@/Enums/Beeswax/BeeswaxSegmentUserCountRegion.enum';
import type { IControlOption } from '@/Interfaces/ControlOption.interface';
import type { IUserCountByRegion } from '@/Interfaces/Segments/Segment.interface';
import ArchiveButton, { type IArchiveButtonProps } from '@/components/Grid/ArchiveButton';
import ControlOptionChip from '@/components/Grid/ControlOptionChip';
import ViewButton, { type IViewButtonProps } from '@/components/Grid/ViewButton';
import { defaultQuickFilter } from '@/helpers/grid/quickFilter';
import { fallbackValueFormatter } from '@/helpers/grid/valueFormatter.helpers';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import { numberToUsFormat } from '@/helpers/valueFormatter/numberFormatter.helpers';
import { Link } from '@mui/material';
import { type GridColDef, type GridRenderCellParams, getGridStringQuickFilterFn } from '@mui/x-data-grid-pro';

export const getColumns = (
  onClickView: IViewButtonProps<any>['onClick'],
  onClickArchive: IArchiveButtonProps['onClick'],
  isAdmin: boolean,
): GridColDef[] =>
  [
    {
      field: 'name',
      headerName: 'Segment Name',
      getApplyQuickFilterFn: getGridStringQuickFilterFn,
      display: 'flex',
      renderCell: ({ value, row }: GridRenderCellParams) => (
        <Link
          component='button'
          underline='hover'
          sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
          onClick={() => onClickView(row)}
        >
          {value}
        </Link>
      ),
      flex: 3,
    },
    {
      field: 'segmentId',
      headerName: 'ID',
      flex: 0.7,
    },
    {
      field: 'advertiser',
      headerName: 'Advertiser',
      align: 'center',
      valueFormatter: (value: IControlOption) => fallbackValueFormatter(value?.label),
      display: 'flex',
      renderCell: ControlOptionChip,
      flex: 1.5,
    },
    {
      field: 'dateCreated',
      headerName: 'Date Created',
      valueFormatter: (value: string) => dateToShortFormat(value),
      flex: 1.5,
    },
    {
      field: 'userCountByRegion',
      headerName: 'Segment Count',
      valueGetter: (value: IUserCountByRegion) => numberToUsFormat(value?.[BeeswaxSegmentUserCountRegion.NAM] ?? 0),
      flex: 1.5,
    },
    {
      field: 'active',
      headerName: 'Active',
      align: 'center',
      sortable: false,
      headerAlign: 'center',
      minWidth: 150,
      flex: 2,
      disableExport: true,
      display: 'flex',
      renderCell: (params: GridRenderCellParams) => (
        <>
          <ViewButton {...params} onClick={onClickView} />
          {isAdmin && <ArchiveButton {...params} onClick={onClickArchive} />}
        </>
      ),
    },
  ].map(item => ({
    ...item,
    flex: item.flex ?? 1,
    getApplyQuickFilterFn: item.getApplyQuickFilterFn || defaultQuickFilter,
  })) as GridColDef[];
